window.JAM = window.JAM || {};
window.JAM.pages = window.JAM.pages || {};

$(function () {
  const $landingPagesShow = $(".landing-pages-show");

  if (!$landingPagesShow.length) {
    return;
  }

  const $pageData = $("#page-data");
  const autoRedirect = $pageData.data("auto-redirect");
  const autoRedirectDelay = $pageData.data("auto-redirect-delay");

  if (autoRedirect) {
    setTimeout(() => {
      JAM.components.common.showLoader();
      $landingPagesShow.find("form").first().trigger("submit");
    }, autoRedirectDelay || 1000);
  }
});

window.JAM.pages.landingPage = (() => {
  const init = () => {
    const $landingPagesShow = $(".landing-pages-show");

    if (!$landingPagesShow.length) {
      return;
    }

    handleAutoRedirect();
    handleFormSubmit();
  };

  const handleAutoRedirect = () => {
    const $pageData = $("#page-data");
    const autoRedirect = $pageData.data("auto-redirect");
    const autoRedirectDelay = $pageData.data("auto-redirect-delay");

    if (autoRedirect) {
      setTimeout(() => {
        JAM.components.common.showLoader();
        $landingPagesShow.find("form").first().trigger("submit");
      }, autoRedirectDelay || 1000);
    }
  };

  const handleFormSubmit = () => {
    $("form").on("submit", function () {
      JAM.components.common.showLoader();
    });

    $("form").on("ajax:complete", function () {
      JAM.components.common.hideLoader();
    });
  };

  return {
    init,
  };
})();

$(function () {
  window.JAM.pages.landingPage.init();
});
